import axios from 'axios';
import { getToken, clearAuth } from '../utils/auth';

const baseURL = process.env.REACT_APP_API_URL;

const axiosClient = axios.create({ baseURL });

const handleResponse = (res) => res.data;
const handleError = (err) => {
  // BE returns 401 when the JWT is missing/expired/invalid. Drop the
  // stale auth state so the next route guard kicks the user back to
  // /admin/login instead of looping forever on a dead token.
  if (err?.response?.status === 401) clearAuth();
  return Promise.reject(err);
};

axiosClient.interceptors.request.use(
  (req) => {
    const token = getToken();
    if (token) req.headers.Authorization = `Bearer ${token}`;
    return req;
  },
  (err) => Promise.reject(err)
);

axiosClient.interceptors.response.use(handleResponse, handleError);

export default axiosClient;
